import { useSyncExternalStore } from 'react';

/** The one layout breakpoint (Tailwind's `md`): below it the phone layout, from it up the desktop layout. */
export const PHONE_QUERY = '(max-width: 767.98px)';

/** Live `matchMedia` result. Where matchMedia is missing (tests, old browsers) it reports the desktop layout. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const mq = window.matchMedia?.(query);
      mq?.addEventListener?.('change', notify);
      return () => mq?.removeEventListener?.('change', notify);
    },
    () => !!window.matchMedia?.(query).matches,
    () => false,
  );
}

export const usePhone = () => useMediaQuery(PHONE_QUERY);
